import { Component, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { V1_ROOT_FALLBACK } from './v1-root-fallback.token';

/**
 * Stub component for default route for hybrid app to override the injected default.
 */
@Component({ template: '', standalone: true })
export class V1ClassicPageComponent {}

/** Guards the root path, passing through existing v1 fragments or redirecting to `V1_ROOT_FALLBACK`. */
export const v1RootGuard = (route: ActivatedRouteSnapshot): true | UrlTree => {
  const fragment = route.fragment;

  if (fragment && `#${fragment}`.startsWith('#/app')) {
    return true;
  }

  return inject(Router).parseUrl(inject(V1_ROOT_FALLBACK));
};
